export default __webpack_public_path__ + "static/media/img_14.0f30cbc6.jpg";